import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

const AsyncRecommendPremiumToStandardModalComponent = lazyAfterPaint(() =>
	import(/* webpackChunkName:  "async-recommend-premium-to-standard-modal" */ './index.tsx').then(
		({ RecommendPremiumToStandardModalComponent }) => RecommendPremiumToStandardModalComponent,
	),
);

export default AsyncRecommendPremiumToStandardModalComponent;
